$(() => {
  if (!$('.js-hhmm-input').length) {
    return
  }

  // 保存用の固定日付
  let BASE_DATE = '2000-01-01'

  // hidden(送信用)に反映する
  let copyValue = (wrapper) => {
    let hour = wrapper.find('.js-hhmm-input_hour').val()
    let minute = wrapper.find('.js-hhmm-input_minute').val()
    let output = wrapper.find('.js-hhmm-input_output')
    if (!hour || !minute) {
      output.val('')
    } else {
      output.val(`${BASE_DATE}T${hour.padStart(2, '0')}:${minute.padStart(2, '0')}`)
    }
  }

  $('.js-hhmm-input').on('change', '.js-hhmm-input_hour,.js-hhmm-input_minute', (e) => {
    copyValue($(e.target).closest('.js-hhmm-input'))
  })
})
